export default __webpack_public_path__ + "static/media/img9.c0b4d276.png";